import React, { createContext, useContext, useState } from "react";

// 創建 Context
const BackgroundContext = createContext();

// 提供 Provider
export const BackgroundProvider = ({ children }) => {
  const [backgroundImage, setBackgroundImage] = useState("");

  return (
    <BackgroundContext.Provider value={{ backgroundImage, setBackgroundImage }}>
      {children}
    </BackgroundContext.Provider>
  );
};

// 自定義 Hook
export const useBackground = () => {
  const context = useContext(BackgroundContext);
  if (!context) {
    throw new Error("useBackground 必須在 BackgroundProvider 內使用");
  }
  return context;
};
